import { Progress } from 'antd'
import { DataList } from 'components/list/data.list'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { removeUpload } from 'store/upload'


import { useAppDispatch, useAppSelector } from 'store'


export const MultipleUploadIndicator: FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const uploads = useAppSelector(state => {
    return state.upload.ids.map(x => state.upload.entities[x])
  })

  const uploadPercentage = useAppSelector(state => {
    return uploads.reduce(
      (total, u) => total + u.progress,
      0,
    ) / uploads.length * 100
  })


  const onClick = () => {
    uploads.forEach(u => {
      if (u.finished || u.failed) {
        dispatch(removeUpload(u.id))
      }
    })
  }

  return (
    <DataList.Item>
      <div
        style={{
          cursor: 'pointer',
          width: 320,
        }}
      >
        <div
          style={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}
        >
          <Progress
            percent={Math.round(uploadPercentage)}
            status={uploadPercentage == 100 ? 'success' : 'active'}
            style={{ width: '96%' }}
          />
        </div>
        <span
          onClick={onClick}
          style={{
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {t('multiple-uploads-running', 'Uploading multiple files')} {`(${uploads.length})`}
        </span>
      </div>
    </DataList.Item>
  )
}
